import styled from "@emotion/styled";
import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KicaLogo from "../Svg/KicaLogo";
import { H2 } from "../typography";
import { useRecoilState } from "recoil";
import { providerState } from "../../../atom/simpleCert";
import { providers } from "../../../constants/simple-cert";

const Box = styled.div`
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 10px;
    padding: 16px;
`;

const Title = styled.div`
    grid-area: title;
    display: flex;
    justify-content: center;
`;

const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background: none;
    color: #1f1f1f;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0;
`;

const HomeButton = styled(Button)`
    height: auto;
    cursor: pointer;
    width: 158px;

    :disabled {
        cursor: unset;
    }
`;

const ProviderLogoBox = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    position: absolute;
    right: 16px;
`;

const ProviderLogo = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 4px;
`;

type Props = {
    children?: ReactNode;
};
export default function Header({ children }: Props) {
    const navigate = useNavigate();
    const [provider, setProvider] = useRecoilState(providerState);
    const location = useLocation();


    const goHome = () => {
        setProvider("");
        navigate("/");
    };

    return (
        <Box>
            <HomeButton onClick={goHome} title={"홈 버튼"} disabled={location.pathname === "/"}> <KicaLogo /> </HomeButton>
            <Title><H2>{children}</H2></Title>
            {provider &&
                <ProviderLogoBox>
                    <ProviderLogo src={providers[provider].url} alt={providers[provider].text} />
                </ProviderLogoBox>
            }
        </Box>
    );
}
